export const Parents = [
	"Electronics",
	"Clothing",
	"Automobile",
	"Home and Garden",
	"Health and Beauty",
	"Sports and Outdoors",
	"Toys and Games",
	"Books and Media",
	"Furniture and Decor",
	"Jewelry and Accessories",
	"Food and Groceries",
	"Pet Supplies",
	"Art and Crafts",
	"Office Supplies",
	"Music and Instruments",
	"Travel and Luggage",
	"Electronics Accessories",
	"Industrial and Scientific",
	"Baby and Kids",
	"Party and Event Supplies",
];
